export default "<div *ngIf=\"pageLoadingFlag\">\r\n    <app-matrix-wave-loading></app-matrix-wave-loading>\r\n</div>\r\n\r\n<router-outlet></router-outlet>"